import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';

const Button = forwardRef(
  (
    { children, type = 'button', className = 'btn btn-primary', ...rest }: any,
    ref,
  ) => (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.95 }}
      type={type}
      className={className}
      ref={ref}
      {...rest}
    >
      {children}
    </motion.button>
  ),
);

export default Button;
